<template>
  <div class="agreement">
    <div class="charter-content">
      <div class="charter-position charter-name">《黄石市建设工程电子交易系统用户服务协议》</div>
      <div class="part">
        <h3><div class="special">【特别提示】（请先下载并认真填写后加盖公章）<a href="https://gcjs.hsztbzx.com:443/template/t_p_template/湖北省公共资源招标投标事前信用承诺书（范本）.docx"><h3><u>《湖北省公共资源招标投标事前信用承诺书（范本）》</u></h3></a>&nbsp;&nbsp;<a href="https://gcjs.hsztbzx.com:443/template/t_p_template/法人授权委托书.doc"><u>《法人授权委托书》</u></a></div></h3>
        <p style="padding-left: 0">
          黄石市建设工程电子交易系统用户服务（以下简称“本服务”）是由黄石市公共资源交易中心创建的建设工程电子交易系统提供给用户电子招投标信息化服务。为使用本服务，用户应当阅读并遵守《黄石市建设工程电子交易系统用户服务协议》（以下简称“本协议”）。
          请您务必审慎阅读、充分理解各条款内容。除非您已阅读并同意接受本协议所有条款，否则您无权使用平台提供的服务。
        </p>
      </div>
      <div class="part">
        <h3>
          一、【协议范围】
        </h3>
        <p>
          1.1 本协议是您与黄石市公共资源交易中心之间关于用户使用黄石市建设工程电子交易系统相关服务所订立的协议。
        </p>
        <p>
          1.2 黄石市建设工程电子交易系统是指黄石市公共资源交易中心及其相关服务可能存在关联的运营单位所提供的电子招投标信息化产品及服务。“用户“是指使用黄石市建设工程电子招投标交易系统相关招投标信息化服务的使用人，在本协议中更多的称为“您”。
        </p>
      </div>
      <div class="part">
        <h3>
          二、【协议的生效与变更】
        </h3>
        <p>
          2.1   您使用“本服务”即视为您已阅读本协议并接受本协议的约束。
        </p>
        <p>
          2.2   黄石市公共资源交易中心有权在必要时定期或不定期修改本协议条款。您可以在黄石市公共资源交易中心网站相关页面查阅最新版本的协议条款。
        </p>
        <p>
          2.3  本协议条款变更后，如果您继续使用“本服务”，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本服务。
        </p>
        <p>
          2.4  除非特别声明，某些增强服务的新功能增加仍将适用本协议。
        </p>
        <p>
          2.5  本协议的解释、修改等权益由黄石市公共资源交易中心享有；未经黄石市公共资源交易中心授权，任何人不得擅自修改本协议。
        </p>
      </div>
      <div class="part">
        <h3>
          三、【服务内容】
        </h3>
        <p>
          3.1  本协议所述服务仅在黄石市建设工程电子交易系统内有效。黄石市建设工程电子交易系统是指www.hsztbzx.com及其所属网页。
        </p>
        <p>
          3.2  黄石市建设工程电子交易系统服务的具体内容由黄石市公共资源交易中心根据平台实际情况提供。
        </p>
        <p>
          3.3  黄石市公共资源交易中心有权根据平台实际情况随时调整服务内容，并无需对任何用户或任何第三方承担任何责任。
        </p>
        <p>
          3.4  黄石市建设工程电子交易系统仅提供电子招投标信息化相关服务。除此之外，与相关服务有关的设备（如电脑、调制解调器及其接入互联网有关的装置等）及所需的费用（如为接入互联网而支付的电话费、上网费等）均由使用用户自行承担。
        </p>
      </div>
      <div class="part">
        <h3>
          四、【用户的权利义务】
        </h3>
        <p>
          4.1 用户在申请及使用“本服务”时，必须注册，并在注册时向黄石市建设工程电子交易系统提供准确完整的用户资料，如用户资料有任何变动，必须及时更新。
        </p>
        <p>
          4.2 用户注册成功后，黄石市建设工程电子交易系统将给予每位用户对应一个用户帐号及相应密码。该用户帐号和密码由用户负责保管，并仅限用户自用，用户不得将其帐号、密码转让或出借予他人使用；用户应当对以其使用帐号进行的所有活动和事件负法律责任。
        </p>
        <p>
          4.3 如用户发现其帐号遭他人非法使用，应立即通知黄石市公共资源交易中心。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，黄石市建设工程电子交易系统运营单位不承担任何责任。
        </p>
        <p>
          4.4 您理解并同意，在使用本服务的过程中，必须遵守以下原则：
        </p><ul>
        <li>（1） 遵守中华人民共和国有关法律、法规；</li>
        <li>（2） 遵守所有与网络服务有关的网络协议，规定和程序；</li>
        <li>（3） 不得为任何非法目的而使用网络服务系统；</li>
        <li>（4） 不得以任何形式使用黄石市建设工程电子交易系统服务侵犯黄石市建设工程电子交易系统的商业利益，包括并不限于发布非经黄石市建设工程电子交易系统许可的商业广告；</li>
        <li>（5） 不得利用黄石市建设工程电子交易系统服务系统进行任何可能对互联网正常运转造成不利影响的行为；</li>
        <li>（6） 不得利用黄石市建设工程电子交易系统提供的服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；</li>
        <li>（7） 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权、隐私、声誉或其他任何合法权益；</li>
        <li>（8） 不得利用黄石市建设工程电子交易系统服务系统进行任何不利于黄石市建设工程电子交易系统服务的行为；</li>
        <li>（9） 用户须对自己发布的信息负责。</li>
      </ul>
        <p></p>
      </div>
      <div class="part">
        <h3>
          五、【不可抗力及其他免责事由】
        </h3>
        <p>
          5.1  您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断，不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，黄石市公共资源交易中心将努力在第一时间与平台相关运营单位配合，及时进行修复，但是由此给您造成的损失中心在法律允许的范围内免责。
        </p>
        <p>
          5.2  在法律允许的范围内，黄石市公共资源交易中心对以下情形导致的“本服务”中断或受阻不承担责任，但将尽力减少因此而给您造成的损失和影响：
        </p><ul>
        <li>（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</li>
        <li>（2）用户或中心电脑系统硬件、通信线路出现故障及因政府管制造成的暂时性关闭在内的任何影响网络正常运营的因素；</li>
      </ul>
        <p></p>
        <p>
          5.3 您理解并同意，如发生下列任何情形，黄石市公共资源交易中心有权中断或终止向您提供“本服务”，并无需对使用用户或任何第三方承担任何责任：
        </p><ul>
        <li>（1）根据法律规定，您应提交真实信息，而您提供的资料不真实或与注册时信息不一致又未能提供合理证明；</li>
        <li>（2） 您违反相关法律法规或本协议的约定；</li>
      </ul>
        <p></p>
      </div>
      <div class="part">
        <h3>
          六、【服务费用】
        </h3>
        <p>
          6.1 用户理解并同意，黄石市建设工程电子交易系统所提供的电子招投标信息化服务为付费服务，收费标准以黄石市公共资源交易中心门户网相关页面上公布的通知为准。
        </p>
        <p>
          6.2 申请服务用户向黄石市建设工程电子交易系统支付所申请具体费用后，方可享受相应服务。黄石市建设工程电子交易系统运营单位有权根据平台实际情况单方调整价格标准和支付条件。
        </p>
        <p>
          6.3 在服务开通到期满续约之前，不受在此期间黄石市建设工程电子交易系统服务价格影响。若在服务期满前请求终止服务，剩余费用不予退还。
        </p>
      </div>
      <div class="part">
        <h3>
          七、【服务声明】
        </h3>
        <p>
          7.1 黄石市建设工程电子交易系统对其网站上提供的信息及服务有效性、准确性、正确性、可靠性、质量、稳定、完整和及时性等均不作承诺和保证；
        </p>
        <p>
          7.2 用户理解并接受任何信息资料的传输取决于电子招投标信息化服务用户本身并由其承担系统受损或资料丢失的所有风险和责任；
        </p>
        <p>
          7.3 黄石市建设工程电子交易系统运营单位对电子招投标信息化服务用户之间的商业进程不作任何明示或暗示的承诺与保证；
        </p>
        <p>
          7.4本网提供与其他相关互联网网站或资源的链接．但不对此类网站或资源的真实、有效性负责。链接网站或资源上提供的任何内容、宣传、产品或服务与本网站无关。
        </p>
      </div>
      <div class="part">
        <h3>
          八、【通知送达】
        </h3>
        <p>
          黄石市建设工程电子交易系统向用户发送的所有通知均可通过黄石市公共资源交易中心门户网相关页面公告、电子邮件、手机短信或常规的信件传送等任意一方式进行；该等通知于发送之日视为已送达用户。
        </p>
      </div>
      <div class="part">
        <h3>
          九、【版权声明】
        </h3>
        <p>
          9.1  黄石市公共资源交易中心与使用用户，在“本服务”过程中，任何一方未履行所规定的责任均视为违约。按照《合同法》规定处理：如双方发生纠纷，应尽量友好协商解决；
        </p>
        <p>
          9.2  本协议适用中华人民共和国法律（不包括冲突法），如与本协议有关的某一特定事项缺乏明确法律规定，则应参照通用的国际商业惯例和行业惯例。
        </p>
        <p>
          9.3 黄石市建设工程电子交易系统的所有内容版权属黄石市公共资源交易中心所有，严禁未经黄石市公共资源交易中心书面许可，不得以任何形式拷贝部分或全部内容。
        </p>
      </div>
      <div class="part">
        <h3>
          十、【其他】
        </h3>
        <p>
          如果您对本协议或本服务有意见或建议，可与黄石市公共资源交易中心联系，我们会给予您必要的帮助。
        </p>
      </div>
      <div class="part">

        <a href="https://gcjs.hsztbzx.com:443/template/t_p_template/湖北省公共资源招标投标事前信用承诺书（范本）.docx"><h3><u>《湖北省公共资源招标投标事前信用承诺书（范本）》</u></h3></a>
      </div>
      <div class="part">
        <a href="https://gcjs.hsztbzx.com:443/template/t_p_template/法人授权委托书.doc"><h3><u>《法人授权委托书》</u></h3></a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "one"
  }
</script>

<style lang="scss" scoped>
  *{
    font-size: 12px;
    border:0;
    margin:0;
    padding:0;
    zoom:1;
  }
  .agreement{
    margin-top: 40px;
    .charter-content {
      width: 1025px;
      padding: 10px 40px 30px;
      -moz-box-shadow: 1px 0 8px #b5b5b6;
      box-shadow: 1px 0 8px #b5b5b6;
      margin: 0 auto;
      overflow: auto;
      box-sizing: border-box;
      font-size: 14px;
      .charter-name {
        font-size: 24px;
        font-weight: bold;
      }
      .charter-position {
        padding: 10px;
        text-align: center;
        margin: 0 auto;
      }
      .part {
        margin-top: 14px;
        line-height: 25px;
        h3{
          font-size: 16px;
          font-weight: bold;
          .special {
            color: #f00;
            text-align: center;
            a, a:hover, a:link, a:focus, a:active {
              text-decoration: none;
            }
          }
        }
        p {
          margin-top: 10px;
          padding-left: 20px;
          box-sizing: border-box;
        }
        a{
          color: #1890FF;
        }
      }
    }
  }
</style>
